module.exports = __webpack_public_path__ + "img/523.b277ae00.jpg";